import styled from 'styled-components/macro';

export const TopContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  overflow-y: auto;
`;

export const InfoWrapper = styled.div`
  padding: 0 30px;
`;
